import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function PayeeStatusUpsert(param: any) {

    let [payeeStatus, setpayeeStatus] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            payeeStatus = param?.editDataDawer
            setpayeeStatus(payeeStatus)
        }
    }

    const onSave = () => {
        systemFormatsList.saveStatusPayee(payeeStatus).then((respond: any) => {
            CommonUtilities.showToastDawer('Payee Status Saved', 'Success')
        })
    }

    return (<>
        <Drawer open={param?.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Payee Status Ext</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">

                        <div className="ws-12">

                            <div className="form-format">
                                <label className="control-label">
                                    Payee Status UseID
                                </label>

                                <div className="label-entries">
                                    <input type="number" placeholder="Payee Status Use ID" ng-disabled="IsDisabled" data-ng-model="payeeStatus.payeeStatusUseID" id="payeeStatusUseID" name="payeeStatusUseID" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">
                                    Payee Status Name
                                </label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Payee Status Name" data-ng-model="payeeStatus.payeeStatusName" id="payeeStatusName" name="payeeStatusName" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">  Payee Status Short Code </label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Payee Status Short Code" data-ng-model="payeeStatus.payeeStatusShortCode" id="payeeStatusShortCode" name="payeeStatusShortCode" />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12 ptl">
                            <div className="ws-6">
                                <div className="mbl">
                                    RecMYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="payeeStatus.recMYN" />
                                        <span className="slider round text-left white pm pts " ng-show="payeeStatus.recMYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!payeeStatus.recMYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    PublYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="payeeStatus.publYN" />
                                        <span className="slider round text-left white pm pts " ng-show="payeeStatus.publYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!payeeStatus.publYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    MechYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="payeeStatus.mechYN" />
                                        <span className="slider round text-left white pm pts " ng-show="payeeStatus.mechYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!payeeStatus.mechYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    ApprovalYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="payeeStatus.approvalYN" />
                                        <span className="slider round text-left white pm pts " ng-show="payeeStatus.approvalYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!payeeStatus.approvalYN =='1'">No</span>
                                    </label>
                                </div>
                            </div>

                            <div className="ws-6">
                                <div className="mbl">
                                    ControlRptYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="payeeStatus.controlRptYN" />
                                        <span className="slider round text-left white pm pts " ng-show="payeeStatus.controlRptYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!payeeStatus.controlRptYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    EmailYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="payeeStatus.emailYN" />
                                        <span className="slider round text-left white pm pts " ng-show="payeeStatus.emailYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!payeeStatus.emailYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    AutoLTD
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="payeeStatus.autoLTD" />
                                        <span className="slider round text-left white pm pts " ng-show="payeeStatus.autoLTD=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!payeeStatus.autoLTD =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    IsDefault
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="payeeStatus.isDefault" />
                                        <span className="slider round text-left white pm pts " ng-show="payeeStatus.isDefault=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!payeeStatus.isDefault =='1'">No</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}